// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { RegistrationProcessForm, RegistrationProcessSteps, RegistrationProcessStepStatus, RegistrationProcessFormAndSteps } from "../schema";

export function serialize_RegistrationProcessFormAndSteps(obj: RegistrationProcessFormAndSteps): string {
  const serialized = ((value: { form: RegistrationProcessForm; steps: RegistrationProcessSteps }): unknown => {
    return {
      form: ((value: {
        address1: string;
        address2: string;
        city: string;
        company: string;
        companyBilling: boolean;
        country: string;
        countryStudy: string;
        currency: string;
        department: string;
        email: string;
        firstName: string;
        lastName: string;
        password: string;
        paymentStatus: string;
        paymentType: string;
        postalCode: string;
        privacyPolicy: boolean;
        productId: bigint;
        promotionCode: string;
        registrationId: bigint;
        registrationUuId: string;
        state: string;
        studyField: string;
        teamOrganisation: string;
        teamUsername: string;
        telephone: string;
        termsAndConditions: boolean;
        title: boolean;
        verificationFile: string;
        verificationFileBytes: ReadonlyUint8Array;
      }): unknown => {
        return {
          address1: ((value: string): unknown => {
            return value;
          })(value["address1"]),
          address2: ((value: string): unknown => {
            return value;
          })(value["address2"]),
          city: ((value: string): unknown => {
            return value;
          })(value["city"]),
          company: ((value: string): unknown => {
            return value;
          })(value["company"]),
          companyBilling: ((value: boolean): unknown => {
            return value;
          })(value["companyBilling"]),
          country: ((value: string): unknown => {
            return value;
          })(value["country"]),
          countryStudy: ((value: string): unknown => {
            return value;
          })(value["countryStudy"]),
          currency: ((value: string): unknown => {
            return value;
          })(value["currency"]),
          department: ((value: string): unknown => {
            return value;
          })(value["department"]),
          email: ((value: string): unknown => {
            return value;
          })(value["email"]),
          firstName: ((value: string): unknown => {
            return value;
          })(value["firstName"]),
          lastName: ((value: string): unknown => {
            return value;
          })(value["lastName"]),
          password: ((value: string): unknown => {
            return value;
          })(value["password"]),
          paymentStatus: ((value: string): unknown => {
            return value;
          })(value["paymentStatus"]),
          paymentType: ((value: string): unknown => {
            return value;
          })(value["paymentType"]),
          postalCode: ((value: string): unknown => {
            return value;
          })(value["postalCode"]),
          privacyPolicy: ((value: boolean): unknown => {
            return value;
          })(value["privacyPolicy"]),
          productId: ((value: bigint): unknown => {
            return value;
          })(value["productId"]),
          promotionCode: ((value: string): unknown => {
            return value;
          })(value["promotionCode"]),
          registrationId: ((value: bigint): unknown => {
            return value;
          })(value["registrationId"]),
          registrationUuId: ((value: string): unknown => {
            return value;
          })(value["registrationUuId"]),
          state: ((value: string): unknown => {
            return value;
          })(value["state"]),
          studyField: ((value: string): unknown => {
            return value;
          })(value["studyField"]),
          teamOrganisation: ((value: string): unknown => {
            return value;
          })(value["teamOrganisation"]),
          teamUsername: ((value: string): unknown => {
            return value;
          })(value["teamUsername"]),
          telephone: ((value: string): unknown => {
            return value;
          })(value["telephone"]),
          termsAndConditions: ((value: boolean): unknown => {
            return value;
          })(value["termsAndConditions"]),
          title: ((value: boolean): unknown => {
            return value;
          })(value["title"]),
          verificationFile: ((value: string): unknown => {
            return value;
          })(value["verificationFile"]),
          verificationFileBytes: ((value: ReadonlyUint8Array): unknown => {
            return toBase64(value);
          })(value["verificationFileBytes"]),
        };
      })(value["form"]),
      steps: ((value: {
        accountForm: RegistrationProcessStepStatus;
        finishStep: RegistrationProcessStepStatus;
        paymentForm: RegistrationProcessStepStatus;
        studentForm: RegistrationProcessStepStatus;
        teamsForm: RegistrationProcessStepStatus;
      }): unknown => {
        return {
          accountForm: ((value: { step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED" }): unknown => {
            return {
              step: ((value: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"): unknown => {
                return value;
              })(value["step"]),
            };
          })(value["accountForm"]),
          finishStep: ((value: { step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED" }): unknown => {
            return {
              step: ((value: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"): unknown => {
                return value;
              })(value["step"]),
            };
          })(value["finishStep"]),
          paymentForm: ((value: { step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED" }): unknown => {
            return {
              step: ((value: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"): unknown => {
                return value;
              })(value["step"]),
            };
          })(value["paymentForm"]),
          studentForm: ((value: { step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED" }): unknown => {
            return {
              step: ((value: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"): unknown => {
                return value;
              })(value["step"]),
            };
          })(value["studentForm"]),
          teamsForm: ((value: { step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED" }): unknown => {
            return {
              step: ((value: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"): unknown => {
                return value;
              })(value["step"]),
            };
          })(value["teamsForm"]),
        };
      })(value["steps"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_RegistrationProcessFormAndSteps(str: string): ParserResult<RegistrationProcessFormAndSteps> {
  return ((
    value: unknown,
  ): ParserResult<{
    form: RegistrationProcessForm;
    steps: RegistrationProcessSteps;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/RegistrationProcessFormAndSteps]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/RegistrationProcessFormAndSteps]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "form")) {
      return { success: false, reason: `[#/components/schemas/RegistrationProcessFormAndSteps/form]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'form'.` };
    }
    const parsed_form = ((): ParserResult<RegistrationProcessForm> => {
      return ((value: unknown): ParserResult<RegistrationProcessForm> => {
        return ((
          value: unknown,
        ): ParserResult<{
          address1: string;
          address2: string;
          city: string;
          company: string;
          companyBilling: boolean;
          country: string;
          countryStudy: string;
          currency: string;
          department: string;
          email: string;
          firstName: string;
          lastName: string;
          password: string;
          paymentStatus: string;
          paymentType: string;
          postalCode: string;
          privacyPolicy: boolean;
          productId: bigint;
          promotionCode: string;
          registrationId: bigint;
          registrationUuId: string;
          state: string;
          studyField: string;
          teamOrganisation: string;
          teamUsername: string;
          telephone: string;
          termsAndConditions: boolean;
          title: boolean;
          verificationFile: string;
          verificationFileBytes: ReadonlyUint8Array;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "address1")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/address1]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'address1'.` };
          }
          const parsed_address1 = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/address1]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["address1"]);
          })();
          if (!parsed_address1.success) {
            return { success: false, reason: parsed_address1.reason };
          }
          if (!hasProp(value, "address2")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/address2]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'address2'.` };
          }
          const parsed_address2 = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/address2]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["address2"]);
          })();
          if (!parsed_address2.success) {
            return { success: false, reason: parsed_address2.reason };
          }
          if (!hasProp(value, "city")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/city]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'city'.` };
          }
          const parsed_city = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/city]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["city"]);
          })();
          if (!parsed_city.success) {
            return { success: false, reason: parsed_city.reason };
          }
          if (!hasProp(value, "company")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/company]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'company'.` };
          }
          const parsed_company = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/company]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["company"]);
          })();
          if (!parsed_company.success) {
            return { success: false, reason: parsed_company.reason };
          }
          if (!hasProp(value, "companyBilling")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/companyBilling]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'companyBilling'.` };
          }
          const parsed_companyBilling = ((): ParserResult<boolean> => {
            return ((value: unknown): ParserResult<boolean> => {
              if (typeof value !== "boolean") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/companyBilling]: '${value}' expected to be of type boolean.` };
              }
              return { success: true, value: value };
            })(value["companyBilling"]);
          })();
          if (!parsed_companyBilling.success) {
            return { success: false, reason: parsed_companyBilling.reason };
          }
          if (!hasProp(value, "country")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/country]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'country'.` };
          }
          const parsed_country = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/country]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["country"]);
          })();
          if (!parsed_country.success) {
            return { success: false, reason: parsed_country.reason };
          }
          if (!hasProp(value, "countryStudy")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/countryStudy]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryStudy'.` };
          }
          const parsed_countryStudy = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/countryStudy]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["countryStudy"]);
          })();
          if (!parsed_countryStudy.success) {
            return { success: false, reason: parsed_countryStudy.reason };
          }
          if (!hasProp(value, "currency")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/currency]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'currency'.` };
          }
          const parsed_currency = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/currency]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["currency"]);
          })();
          if (!parsed_currency.success) {
            return { success: false, reason: parsed_currency.reason };
          }
          if (!hasProp(value, "department")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/department]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'department'.` };
          }
          const parsed_department = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/department]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["department"]);
          })();
          if (!parsed_department.success) {
            return { success: false, reason: parsed_department.reason };
          }
          if (!hasProp(value, "email")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/email]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'email'.` };
          }
          const parsed_email = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/email]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["email"]);
          })();
          if (!parsed_email.success) {
            return { success: false, reason: parsed_email.reason };
          }
          if (!hasProp(value, "firstName")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/firstName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'firstName'.` };
          }
          const parsed_firstName = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/firstName]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["firstName"]);
          })();
          if (!parsed_firstName.success) {
            return { success: false, reason: parsed_firstName.reason };
          }
          if (!hasProp(value, "lastName")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/lastName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'lastName'.` };
          }
          const parsed_lastName = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/lastName]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["lastName"]);
          })();
          if (!parsed_lastName.success) {
            return { success: false, reason: parsed_lastName.reason };
          }
          if (!hasProp(value, "password")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/password]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'password'.` };
          }
          const parsed_password = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/password]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["password"]);
          })();
          if (!parsed_password.success) {
            return { success: false, reason: parsed_password.reason };
          }
          if (!hasProp(value, "paymentStatus")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/paymentStatus]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'paymentStatus'.` };
          }
          const parsed_paymentStatus = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/paymentStatus]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["paymentStatus"]);
          })();
          if (!parsed_paymentStatus.success) {
            return { success: false, reason: parsed_paymentStatus.reason };
          }
          if (!hasProp(value, "paymentType")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/paymentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'paymentType'.` };
          }
          const parsed_paymentType = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/paymentType]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["paymentType"]);
          })();
          if (!parsed_paymentType.success) {
            return { success: false, reason: parsed_paymentType.reason };
          }
          if (!hasProp(value, "postalCode")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/postalCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'postalCode'.` };
          }
          const parsed_postalCode = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/postalCode]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["postalCode"]);
          })();
          if (!parsed_postalCode.success) {
            return { success: false, reason: parsed_postalCode.reason };
          }
          if (!hasProp(value, "privacyPolicy")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/privacyPolicy]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'privacyPolicy'.` };
          }
          const parsed_privacyPolicy = ((): ParserResult<boolean> => {
            return ((value: unknown): ParserResult<boolean> => {
              if (typeof value !== "boolean") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/privacyPolicy]: '${value}' expected to be of type boolean.` };
              }
              return { success: true, value: value };
            })(value["privacyPolicy"]);
          })();
          if (!parsed_privacyPolicy.success) {
            return { success: false, reason: parsed_privacyPolicy.reason };
          }
          if (!hasProp(value, "productId")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/productId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'productId'.` };
          }
          const parsed_productId = ((): ParserResult<bigint> => {
            return ((value: unknown): ParserResult<bigint> => {
              if (typeof value === "number") {
                return { success: true, value: BigInt(value) };
              }
              if (typeof value === "bigint") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/productId]: '${value}' expected to be of type bigint or number.` };
            })(value["productId"]);
          })();
          if (!parsed_productId.success) {
            return { success: false, reason: parsed_productId.reason };
          }
          if (!hasProp(value, "promotionCode")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/promotionCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'promotionCode'.` };
          }
          const parsed_promotionCode = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/promotionCode]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["promotionCode"]);
          })();
          if (!parsed_promotionCode.success) {
            return { success: false, reason: parsed_promotionCode.reason };
          }
          if (!hasProp(value, "registrationId")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/registrationId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'registrationId'.` };
          }
          const parsed_registrationId = ((): ParserResult<bigint> => {
            return ((value: unknown): ParserResult<bigint> => {
              if (typeof value === "number") {
                return { success: true, value: BigInt(value) };
              }
              if (typeof value === "bigint") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/registrationId]: '${value}' expected to be of type bigint or number.` };
            })(value["registrationId"]);
          })();
          if (!parsed_registrationId.success) {
            return { success: false, reason: parsed_registrationId.reason };
          }
          if (!hasProp(value, "registrationUuId")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/registrationUuId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'registrationUuId'.` };
          }
          const parsed_registrationUuId = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/registrationUuId]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["registrationUuId"]);
          })();
          if (!parsed_registrationUuId.success) {
            return { success: false, reason: parsed_registrationUuId.reason };
          }
          if (!hasProp(value, "state")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/state]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'state'.` };
          }
          const parsed_state = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/state]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["state"]);
          })();
          if (!parsed_state.success) {
            return { success: false, reason: parsed_state.reason };
          }
          if (!hasProp(value, "studyField")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/studyField]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'studyField'.` };
          }
          const parsed_studyField = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/studyField]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["studyField"]);
          })();
          if (!parsed_studyField.success) {
            return { success: false, reason: parsed_studyField.reason };
          }
          if (!hasProp(value, "teamOrganisation")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/teamOrganisation]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teamOrganisation'.` };
          }
          const parsed_teamOrganisation = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/teamOrganisation]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["teamOrganisation"]);
          })();
          if (!parsed_teamOrganisation.success) {
            return { success: false, reason: parsed_teamOrganisation.reason };
          }
          if (!hasProp(value, "teamUsername")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/teamUsername]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teamUsername'.` };
          }
          const parsed_teamUsername = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/teamUsername]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["teamUsername"]);
          })();
          if (!parsed_teamUsername.success) {
            return { success: false, reason: parsed_teamUsername.reason };
          }
          if (!hasProp(value, "telephone")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/telephone]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'telephone'.` };
          }
          const parsed_telephone = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/telephone]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["telephone"]);
          })();
          if (!parsed_telephone.success) {
            return { success: false, reason: parsed_telephone.reason };
          }
          if (!hasProp(value, "termsAndConditions")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/termsAndConditions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'termsAndConditions'.` };
          }
          const parsed_termsAndConditions = ((): ParserResult<boolean> => {
            return ((value: unknown): ParserResult<boolean> => {
              if (typeof value !== "boolean") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/termsAndConditions]: '${value}' expected to be of type boolean.` };
              }
              return { success: true, value: value };
            })(value["termsAndConditions"]);
          })();
          if (!parsed_termsAndConditions.success) {
            return { success: false, reason: parsed_termsAndConditions.reason };
          }
          if (!hasProp(value, "title")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
          }
          const parsed_title = ((): ParserResult<boolean> => {
            return ((value: unknown): ParserResult<boolean> => {
              if (typeof value !== "boolean") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/title]: '${value}' expected to be of type boolean.` };
              }
              return { success: true, value: value };
            })(value["title"]);
          })();
          if (!parsed_title.success) {
            return { success: false, reason: parsed_title.reason };
          }
          if (!hasProp(value, "verificationFile")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/verificationFile]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verificationFile'.` };
          }
          const parsed_verificationFile = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/verificationFile]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["verificationFile"]);
          })();
          if (!parsed_verificationFile.success) {
            return { success: false, reason: parsed_verificationFile.reason };
          }
          if (!hasProp(value, "verificationFileBytes")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/verificationFileBytes]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verificationFileBytes'.` };
          }
          const parsed_verificationFileBytes = ((): ParserResult<ReadonlyUint8Array> => {
            return ((value: unknown): ParserResult<ReadonlyUint8Array> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/verificationFileBytes]: '${value}' expected to be of type string.` };
              }
              const binary = (() => {
                try {
                  const binaryString = atob(value);
                  const arr = new Uint8Array(binaryString.length);
                  for (let i = 0; i < binaryString.length; i++) {
                    arr[i] = binaryString.charCodeAt(i);
                  }
                  return arr;
                } catch (ex) {
                  return null;
                }
              })();
              if (binary === null) {
                return { success: false, reason: `[#/components/schemas/RegistrationProcessForm/verificationFileBytes]: '${value}' expected to be a valid base64 string.` };
              }
              return { success: true, value: binary };
            })(value["verificationFileBytes"]);
          })();
          if (!parsed_verificationFileBytes.success) {
            return { success: false, reason: parsed_verificationFileBytes.reason };
          }
          return {
            success: true,
            value: {
              address1: parsed_address1.value,
              address2: parsed_address2.value,
              city: parsed_city.value,
              company: parsed_company.value,
              companyBilling: parsed_companyBilling.value,
              country: parsed_country.value,
              countryStudy: parsed_countryStudy.value,
              currency: parsed_currency.value,
              department: parsed_department.value,
              email: parsed_email.value,
              firstName: parsed_firstName.value,
              lastName: parsed_lastName.value,
              password: parsed_password.value,
              paymentStatus: parsed_paymentStatus.value,
              paymentType: parsed_paymentType.value,
              postalCode: parsed_postalCode.value,
              privacyPolicy: parsed_privacyPolicy.value,
              productId: parsed_productId.value,
              promotionCode: parsed_promotionCode.value,
              registrationId: parsed_registrationId.value,
              registrationUuId: parsed_registrationUuId.value,
              state: parsed_state.value,
              studyField: parsed_studyField.value,
              teamOrganisation: parsed_teamOrganisation.value,
              teamUsername: parsed_teamUsername.value,
              telephone: parsed_telephone.value,
              termsAndConditions: parsed_termsAndConditions.value,
              title: parsed_title.value,
              verificationFile: parsed_verificationFile.value,
              verificationFileBytes: parsed_verificationFileBytes.value,
            },
          };
        })(value);
      })(value["form"]);
    })();
    if (!parsed_form.success) {
      return { success: false, reason: parsed_form.reason };
    }
    if (!hasProp(value, "steps")) {
      return { success: false, reason: `[#/components/schemas/RegistrationProcessFormAndSteps/steps]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'steps'.` };
    }
    const parsed_steps = ((): ParserResult<RegistrationProcessSteps> => {
      return ((value: unknown): ParserResult<RegistrationProcessSteps> => {
        return ((
          value: unknown,
        ): ParserResult<{
          accountForm: RegistrationProcessStepStatus;
          finishStep: RegistrationProcessStepStatus;
          paymentForm: RegistrationProcessStepStatus;
          studentForm: RegistrationProcessStepStatus;
          teamsForm: RegistrationProcessStepStatus;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessSteps]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessSteps]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "accountForm")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessSteps/accountForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'accountForm'.` };
          }
          const parsed_accountForm = ((): ParserResult<RegistrationProcessStepStatus> => {
            return ((value: unknown): ParserResult<RegistrationProcessStepStatus> => {
              return ((
                value: unknown,
              ): ParserResult<{
                step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED";
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "step")) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'step'.` };
                }
                const parsed_step = ((): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                  return ((value: unknown): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "REQUIRED":
                        return { success: true, value: "REQUIRED" };
                      case "DONE":
                        return { success: true, value: "DONE" };
                      case "ACTIVE":
                        return { success: true, value: "ACTIVE" };
                      case "UNUSED":
                        return { success: true, value: "UNUSED" };
                      default:
                        return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be enum, one of 'REQUIRED, DONE, ACTIVE, UNUSED'.` };
                    }
                  })(value["step"]);
                })();
                if (!parsed_step.success) {
                  return { success: false, reason: parsed_step.reason };
                }
                return { success: true, value: { step: parsed_step.value } };
              })(value);
            })(value["accountForm"]);
          })();
          if (!parsed_accountForm.success) {
            return { success: false, reason: parsed_accountForm.reason };
          }
          if (!hasProp(value, "finishStep")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessSteps/finishStep]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'finishStep'.` };
          }
          const parsed_finishStep = ((): ParserResult<RegistrationProcessStepStatus> => {
            return ((value: unknown): ParserResult<RegistrationProcessStepStatus> => {
              return ((
                value: unknown,
              ): ParserResult<{
                step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED";
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "step")) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'step'.` };
                }
                const parsed_step = ((): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                  return ((value: unknown): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "REQUIRED":
                        return { success: true, value: "REQUIRED" };
                      case "DONE":
                        return { success: true, value: "DONE" };
                      case "ACTIVE":
                        return { success: true, value: "ACTIVE" };
                      case "UNUSED":
                        return { success: true, value: "UNUSED" };
                      default:
                        return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be enum, one of 'REQUIRED, DONE, ACTIVE, UNUSED'.` };
                    }
                  })(value["step"]);
                })();
                if (!parsed_step.success) {
                  return { success: false, reason: parsed_step.reason };
                }
                return { success: true, value: { step: parsed_step.value } };
              })(value);
            })(value["finishStep"]);
          })();
          if (!parsed_finishStep.success) {
            return { success: false, reason: parsed_finishStep.reason };
          }
          if (!hasProp(value, "paymentForm")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessSteps/paymentForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'paymentForm'.` };
          }
          const parsed_paymentForm = ((): ParserResult<RegistrationProcessStepStatus> => {
            return ((value: unknown): ParserResult<RegistrationProcessStepStatus> => {
              return ((
                value: unknown,
              ): ParserResult<{
                step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED";
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "step")) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'step'.` };
                }
                const parsed_step = ((): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                  return ((value: unknown): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "REQUIRED":
                        return { success: true, value: "REQUIRED" };
                      case "DONE":
                        return { success: true, value: "DONE" };
                      case "ACTIVE":
                        return { success: true, value: "ACTIVE" };
                      case "UNUSED":
                        return { success: true, value: "UNUSED" };
                      default:
                        return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be enum, one of 'REQUIRED, DONE, ACTIVE, UNUSED'.` };
                    }
                  })(value["step"]);
                })();
                if (!parsed_step.success) {
                  return { success: false, reason: parsed_step.reason };
                }
                return { success: true, value: { step: parsed_step.value } };
              })(value);
            })(value["paymentForm"]);
          })();
          if (!parsed_paymentForm.success) {
            return { success: false, reason: parsed_paymentForm.reason };
          }
          if (!hasProp(value, "studentForm")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessSteps/studentForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'studentForm'.` };
          }
          const parsed_studentForm = ((): ParserResult<RegistrationProcessStepStatus> => {
            return ((value: unknown): ParserResult<RegistrationProcessStepStatus> => {
              return ((
                value: unknown,
              ): ParserResult<{
                step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED";
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "step")) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'step'.` };
                }
                const parsed_step = ((): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                  return ((value: unknown): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "REQUIRED":
                        return { success: true, value: "REQUIRED" };
                      case "DONE":
                        return { success: true, value: "DONE" };
                      case "ACTIVE":
                        return { success: true, value: "ACTIVE" };
                      case "UNUSED":
                        return { success: true, value: "UNUSED" };
                      default:
                        return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be enum, one of 'REQUIRED, DONE, ACTIVE, UNUSED'.` };
                    }
                  })(value["step"]);
                })();
                if (!parsed_step.success) {
                  return { success: false, reason: parsed_step.reason };
                }
                return { success: true, value: { step: parsed_step.value } };
              })(value);
            })(value["studentForm"]);
          })();
          if (!parsed_studentForm.success) {
            return { success: false, reason: parsed_studentForm.reason };
          }
          if (!hasProp(value, "teamsForm")) {
            return { success: false, reason: `[#/components/schemas/RegistrationProcessSteps/teamsForm]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teamsForm'.` };
          }
          const parsed_teamsForm = ((): ParserResult<RegistrationProcessStepStatus> => {
            return ((value: unknown): ParserResult<RegistrationProcessStepStatus> => {
              return ((
                value: unknown,
              ): ParserResult<{
                step: "REQUIRED" | "DONE" | "ACTIVE" | "UNUSED";
              }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus]: '${value}' expected to not be null.` };
                }
                if (!hasProp(value, "step")) {
                  return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'step'.` };
                }
                const parsed_step = ((): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                  return ((value: unknown): ParserResult<"REQUIRED" | "DONE" | "ACTIVE" | "UNUSED"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "REQUIRED":
                        return { success: true, value: "REQUIRED" };
                      case "DONE":
                        return { success: true, value: "DONE" };
                      case "ACTIVE":
                        return { success: true, value: "ACTIVE" };
                      case "UNUSED":
                        return { success: true, value: "UNUSED" };
                      default:
                        return { success: false, reason: `[#/components/schemas/RegistrationProcessStepStatus/step]: '${value}' expected to be enum, one of 'REQUIRED, DONE, ACTIVE, UNUSED'.` };
                    }
                  })(value["step"]);
                })();
                if (!parsed_step.success) {
                  return { success: false, reason: parsed_step.reason };
                }
                return { success: true, value: { step: parsed_step.value } };
              })(value);
            })(value["teamsForm"]);
          })();
          if (!parsed_teamsForm.success) {
            return { success: false, reason: parsed_teamsForm.reason };
          }
          return { success: true, value: { accountForm: parsed_accountForm.value, finishStep: parsed_finishStep.value, paymentForm: parsed_paymentForm.value, studentForm: parsed_studentForm.value, teamsForm: parsed_teamsForm.value } };
        })(value);
      })(value["steps"]);
    })();
    if (!parsed_steps.success) {
      return { success: false, reason: parsed_steps.reason };
    }
    return { success: true, value: { form: parsed_form.value, steps: parsed_steps.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
